import React from 'react';

const PageHeaderSkeleton: React.FC = () => {
  return (
    <div className="bg-white dark:bg-dark-800 shadow-sm animate-pulse">
      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Back button and title skeleton */}
        <div className="flex items-center mb-4">
          <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded w-20 mr-4"></div>
          <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded w-32"></div>
        </div>
        
        {/* Description skeleton */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded w-2/3"></div>
          <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded w-1/2"></div>
        </div>
      </div>
    </div>
  );
};

export default PageHeaderSkeleton;

